import { Store } from "../data/store"

export const FilterProducts = c =>
  Store.filter(item => item.categories.includes(c))

export const FilterProductsByShowOnHomepage = c =>
  FilterProducts(c).filter(item => item.showOnHomepage)
